import { render } from "./HymnView.vue?vue&type=template&id=bad437cc&scoped=true"
import script from "./HymnView.vue?vue&type=script&lang=js"
export * from "./HymnView.vue?vue&type=script&lang=js"

import "./HymnView.vue?vue&type=style&index=0&id=bad437cc&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Vue\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad437cc"]])

export default __exports__